import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";

export default function LegalShell({ title, subtitle, lastUpdate, children, canonical }) {
  return (
    <div className="min-h-screen bg-slate-50" data-testid={`legal-${(title || "").toLowerCase().replace(/\s+/g, "-")}`}>
      <SEO title={`${title} — DepannRoute`} description={subtitle} canonical={canonical} />
      <Header />
      <section className="pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-[11px] uppercase tracking-widest font-bold text-orange-600">Document légal</div>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-slate-900 tracking-tight mt-2">{title}</h1>
          {subtitle && <p className="mt-3 text-slate-600 text-lg">{subtitle}</p>}
          {lastUpdate && <div className="mt-3 text-xs text-slate-500">Dernière mise à jour : {lastUpdate}</div>}

          <article className="mt-10 prose prose-slate max-w-none prose-headings:font-display prose-headings:text-slate-900 prose-headings:font-bold prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-3 prose-h3:text-lg prose-p:text-slate-700 prose-li:text-slate-700 prose-a:text-orange-600 prose-a:no-underline hover:prose-a:underline prose-strong:text-slate-900">
            {children}
          </article>
        </div>
      </section>
      <Footer />
    </div>
  );
}
